import axios from "axios"
import { API_URL } from "../../../settings";


const username = 'eventials';
const password = 'w3b1n4r!@#';

const base64Credentials = Buffer.from(`${username}:${password}`).toString('base64');

const api = axios.create({
  baseURL: API_URL,

  headers: {
    'Authorization': `Basic ${base64Credentials}`
  }
});

export async function getEventStyles({ kind }: {
  kind: string
}) {
  const response = api.get(`/api/whitelabel/${kind}/layout/`)

  return response
}

export async function getWebinars({ kind }
  : { kind: string }) {
  const response = api.get(`/api/whitelabel/${kind}/webinars/`)
  return response

}